// extracted by mini-css-extract-plugin
export var fadeInOut = "_46-3";
export var icon = "_46-4";
export var savedIndicator = "_46-2";
export var savingIndicator = "_46-0";
export var spin = "_46-1";